import { render, staticRenderFns } from "./CpvSelector.vue?vue&type=template&id=5f5e2664&scoped=true&"
import script from "./CpvSelector.vue?vue&type=script&lang=js&"
export * from "./CpvSelector.vue?vue&type=script&lang=js&"
import style0 from "./CpvSelector.vue?vue&type=style&index=0&id=5f5e2664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5e2664",
  null
  
)

export default component.exports